module.exports = __webpack_public_path__ + "img/image-10.0690a28d.jpg";